module.exports = __webpack_public_path__ + "img/1482884973.e8c14ad5.jpg";